import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { FaCheckCircle } from "react-icons/fa";
import { getFirestore, collection, doc, setDoc, updateDoc, arrayUnion } from "firebase/firestore";
import FirebaseApp from "../config/Firebase"; // Adjust path to your Firebase config

export default function OrderConfirmation() {
  const location = useLocation();
  const navigate = useNavigate();
  const { orderDetails, product, lensOption } = location?.state || {};
  const db = getFirestore(FirebaseApp);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (orderDetails && orderDetails.email && typeof orderDetails.email === "string") {
      const saveOrder = async () => {
        setIsSaving(true);
        setError(null);
        try {
          // Reference to the document with email as ID in the OrderDetails collection
          const orderRef = doc(collection(db, "OrderDetails"), orderDetails.email);

          // Product details object with status
          const productEntry = {
            productId: product?.ProductID || "22091",
            name: product?.Name || "Adidas",
            frameColor: product?.FrameColor || "Blue",
            material: product?.Material || "TR",
            cost: product?.cost || 1100,
            productId: product?.ProductID || "22091",
            name: product?.Name || "Adidas",
            frameColor: product?.FrameColor || "Blue",
            material: product?.Material || "TR",
            cost: product?.cost || 1100,
            status: "Order Placed",
            orderDate: new Date().toISOString(),
          };
          try {
            await updateDoc(orderRef, {
              products: arrayUnion(productEntry),
              customerDetails: {
                name: orderDetails.name,
                email: orderDetails.email,
                phone: orderDetails.phone,
                address: orderDetails.address,
                pincode: orderDetails.pincode,
              },
              lensOption: {
                id: lensOption?.id || 4,
                id: lensOption?.id || 4,
                leftLensPower: lensOption?.id === 1 ? orderDetails.leftLens || 0 : null,
                rightLensPower: lensOption?.id === 1 ? orderDetails.rightLens || 0 : null,
                name: lensOption?.name || "Frame Only",
                name: lensOption?.name || "Frame Only",
              },
              paymentID: orderDetails.paymentID || "pay_QL1fw3zNItZL6e",
              paymentID: orderDetails.paymentID || "pay_QL1fw3zNItZL6e",
              totalAmount: orderDetails.totalAmount || 1100,
              lastUpdated: new Date().toISOString(),
            });
          } catch (error) {
            if (error.code === "not-found") {
              await setDoc(orderRef, {
                products: [productEntry],
                customerDetails: {
                  name: orderDetails.name,
                  email: orderDetails.email,
                  phone: orderDetails.phone,
                  address: orderDetails.address,
                  pincode: orderDetails.pincode,
                },
                lensOption: {
                  id: lensOption?.id || 4,
                  leftLensPower: lensOption?.id === 1 ? orderDetails.leftLens || 0 : null,
                  rightLensPower: lensOption?.id === 1 ? orderDetails.rightLens || 0 : null,
                  name: lensOption?.name || "Frame Only",
                },
                paymentID: orderDetails.paymentID || "pay_QL1fw3zNItZL6e",
                totalAmount: orderDetails.totalAmount || 1100,
                lastUpdated: new Date().toISOString(),
              });
            } else {
              throw error;
            }
          }
        } catch (error) {
          console.error("Error saving order:", error);
          setError(`Failed to save order: ${error.message}`);
        } finally {
          setIsSaving(false);
        }
      };
      saveOrder();
    } else {
      console.error("Invalid or missing email");
      setError("Invalid order data. Please ensure all required fields are provided.");
    }
  }, [orderDetails, product, lensOption, db]);

  if (!orderDetails) {
    return (
      <div className="flex flex-col items-center justify-center h-screen">
        <p className="text-red-500 text-xl">Order data missing!</p>
        <button
          onClick={() => navigate("/")}
          className="mt-4 px-6 py-2 bg-gray-800 text-white rounded hover:bg-gray-700"
        >
          Go to Home
        </button>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl w-full space-y-8 bg-white p-8 rounded-2xl shadow-xl">
          {isSaving && <p className="text-blue-500 text-center">Saving order...</p>}
          {error && <p className="text-red-500 text-center">{error}</p>}
          <div className="text-center">
            <FaCheckCircle className="text-green-500 text-6xl mx-auto mb-4" />
            <h2 className="text-4xl font-bold text-gray-900">Order Confirmed!</h2>
            <p className="mt-2 text-sm text-gray-900">
              Thank you for your order. A confirmation has been sent to {orderDetails.email}.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Order Summary</h3>
            <div className="space-y-8">
              <div className="pb-4 border-b border-gray-200">
                <h4 className="text-xl font-bold text-black mb-4">Customer Details</h4>
                <dl className="space-y-2">
                  <div className="flex">
                    <dt className="w-1/3 font-medium text-gray-700">Name:</dt>
                    <dd className="w-2/3 text-gray-900">{orderDetails.name}</dd>
                  </div>
                  <div className="flex">
                    <dt className="w-1/3 font-medium text-gray-700">Email:</dt>
                    <dd className="w-2/3 text-gray-900">{orderDetails.email}</dd>
                  </div>
                  <div className="flex">
                    <dt className="w-1/3 font-medium text-gray-700">Phone:</dt>
                    <dd className="w-2/3 text-gray-900">{orderDetails.phone}</dd>
                  </div>
                  <div className="flex">
                    <dt className="w-1/3 font-medium text-gray-700">Address:</dt>
                    <dd className="w-2/3 text-gray-900">{orderDetails.address}</dd>
                  </div>
                  <div className="flex">
                    <dt className="w-1/3 font-medium text-gray-700">Pincode:</dt>
                    <dd className="w-2/3 text-gray-900">{orderDetails.pincode}</dd>
                  </div>
                </dl>
              </div>
              <div className="pb-4 border-b border-gray-200">
                <h4 className="text-xl font-bold text-black mb-4">Product Details</h4>
                <div className="flex gap-4">
                  <img
                    src={product?.ImageUrl1 || "default-image.jpg"}
                    alt={product?.Name || "Product"}
                    className="w-32 h-32 object-cover rounded"
                  />
                  <dl className="space-y-2 flex-1">
                    <div className="flex">
                      <dt className="w-1/3 font-medium text-gray-700">Name:</dt>
                      <dd className="w-2/3 text-gray-900">{product?.Name || "Adidas"}</dd>
                    </div>
                    <div className="flex">
                      <dt className="w-1/3 font-medium text-gray-700">Product ID:</dt>
                      <dd className="w-2/3 text-gray-900">{product?.ProductID || "22091"}</dd>
                    </div>
                    <div className="flex">
                      <dt className="w-1/3 font-medium text-gray-700">Frame Color:</dt>
                      <dd className="w-2/3 text-gray-900">{product?.FrameColor || "Blue"}</dd>
                    </div>
                    <div className="flex">
                      <dt className="w-1/3 font-medium text-gray-700">Material:</dt>
                      <dd className="w-2/3 text-gray-900">{product?.Material || "TR"}</dd>
                    </div>
                    <div className="flex">
                      <dt className="w-1/3 font-medium text-gray-700">Cost:</dt>
                      <dd className="w-2/3 text-gray-900">₹{product?.cost || 1100}</dd>
                    </div>
                  </dl>
                </div>
              </div>
              <div className="pb-4 border-b border-gray-200">
                <h4 className="text-xl font-bold text-black mb-4">Lens Details</h4>
                <dl className="space-y-2">
                  <div className="flex">
                    <dt className="w-1/3 font-medium text-gray-700">Lens Type:</dt>
                    <dd className="w-2/3 text-gray-900">{lensOption?.name || "Frame Only"}</dd>
                  </div>
                  {lensOption?.id === 1 && (
                    <>
                      <div className="flex">
                        <dt className="w-1/3 font-medium text-gray-700">Left Lens Power:</dt>
                        <dd className="w-2/3 text-gray-900">{orderDetails.leftLens || 0} D</dd>
                      </div>
                      <div className="flex">
                        <dt className="w-1/3 font-medium text-gray-700">Right Lens Power:</dt>
                        <dd className="w-2/3 text-gray-900">{orderDetails.rightLens || 0} D</dd>
                      </div>
                    </>
                  )}
                </dl>
              </div>
              <div>
                <h4 className="text-xl font-bold text-black mb-4">Payment & Total</h4>
                <dl className="space-y-2">
                  <div className="flex">
                    <dt className="w-1/3 font-medium text-gray-700">Payment ID:</dt>
                    <dd className="w-2/3 text-gray-900">{orderDetails.paymentID || "pay_QL1fw3zNItZL6e"}</dd>
                  </div>
                  <div className="flex">
                    <dt className="w-1/3 font-medium text-gray-700">Total Amount:</dt>
                    <dd className="w-2/3 text-gray-900">₹{orderDetails.totalAmount || 1100}</dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-4">
            <button
              onClick={() => navigate("/")}
              className="text-center p-3 py-3 bg-black text-white font-bold rounded hover:bg-gray-800 hover:text-white transition-colors duration-200"
            >
              Continue Shopping
            </button>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
}